import SimpleMask from "./SimpleMask";
import PhoneMask from "./PhoneMask";

function install(Vue) {
    Vue.component("v-text-field-simplemask", SimpleMask);
    Vue.component("v-text-field-phonemask", PhoneMask);
}

export default install;
